export const host = process.env.NEXT_PUBLIC_HOST_NAME || 'https://tempcover.com';
export const frontCoverURL = 'front-cover';
export const newsRoomURL = 'news-room';
// articles migrate from /front-cover/* to /guides/* or /news/*
export const guidesURL = 'guides';
export const newsURL = 'news';
export const frontCoverPageSize = 9;
